import {createTableState, normalizePagination} from '@/core/services/Helper'

const state = () => ({
    table: createTableState(),
    statuses: [],
    filterData: undefined
})

// getters
const getters = {}

// actions
const actions = {
    // get records
    async get({state, commit}, {page, filterData}) {
        commit('setLoading', true)

        state.filterData = filterData;

        let params = {
            page: page?.current,
            page_limit: page?.pageSize
        };

        if (state.filterData) {
            params = {...params, ...state.filterData};
        }

        const res = await this._vm.axios.get(this._vm.endpoint.get('ecommerce_order'), {
            params: params
        })

        const {data, meta} = res.data

        commit('updateTableData', data)
        commit('updatePagination', normalizePagination(meta))

        setTimeout(() => {
            commit('setLoading', false)
        }, 250)
    },

    // refresh records
    refresh({state, dispatch}) {
        dispatch('get', {
            page: state.table.pagination,
            filterData: state.filterData
        })
    },

    // show record
    async show({commit, dispatch}, {id}) {
        const response = await this._vm.axios.get(this._vm.endpoint.get('ecommerce_order') + '/' + id)
        return response.data.data
    },

    // update order (status_id, shipping_tracking_number, ...)
    async update({commit, dispatch}, {id, data}) {
        const response = await this._vm.axios.put(this._vm.endpoint.get('ecommerce_order') + '/' + id, data)
        return response.data
    },

    // create manual order
    async create({commit, dispatch}, {data}) {
        const response = await this._vm.axios.post(this._vm.endpoint.get('ecommerce_order'), data)
        return response.data
    },

    // delete order(s)
    async delete({commit, dispatch}, {id}) {
        let successDeleted = [];
        if (!id || id.length === 0) {
            this._vm.$message.warning(this._vm.$t('messages.selectRow'))
        } else {
            for (let i = 0; i < id.length; i++) {
                const {data} = await this._vm.axios.delete(this._vm.endpoint.get('ecommerce_order') + '/' + id[i]);
                if (data.status) {
                    this._vm.$message.success(this._vm.$t('messages.deleteOk'));
                    successDeleted.push(id[i]);
                } else {
                    this._vm.$message.error(data.message)
                }
            }
            dispatch('refresh')
            return successDeleted;
        }
    },

    // export order list (returns file blob)
    async exportList({state}, {filterData} = {}) {
        const response = await this._vm.axios.get(this._vm.endpoint.get('ecommerce_order_export'), {
            params: filterData ?? state.filterData ?? {},
            responseType: 'blob',
        })
        return response
    },

    // ─── Statuses (durum tanımları CRUD) ─────────────────────────────
    async getStatuses({commit}) {
        const response = await this._vm.axios.get(this._vm.endpoint.get('ecommerce_order_status'))
        commit('updateStatuses', response.data.data || [])
        return response.data.data || []
    },

    async showStatus({commit}, {id}) {
        const response = await this._vm.axios.get(this._vm.endpoint.get('ecommerce_order_status') + '/' + id)
        return response.data.data
    },

    async createStatus({commit}, {data}) {
        const response = await this._vm.axios.post(this._vm.endpoint.get('ecommerce_order_status'), data)
        return response.data
    },

    async updateStatusDef({commit}, {id, data}) {
        const response = await this._vm.axios.put(this._vm.endpoint.get('ecommerce_order_status') + '/' + id, data)
        return response.data
    },

    async deleteStatus({commit}, {id}) {
        const response = await this._vm.axios.delete(this._vm.endpoint.get('ecommerce_order_status') + '/' + id)
        return response.data
    },

    // ─── Notes ───────────────────────────────────────────────────────
    async addNote({commit, dispatch}, {order_id, note}) {
        const response = await this._vm.axios.post(this._vm.endpoint.get('ecommerce_order_note'), {order_id, note})
        return response.data
    },

    async deleteNote({commit, dispatch}, {id}) {
        const response = await this._vm.axios.delete(this._vm.endpoint.get('ecommerce_order_note') + '/' + id)
        return response.data
    },

    // ─── Payment collection (tahsilat) ───────────────────────────────
    async addPaymentCollection({commit}, {order_id, amount, note}) {
        const response = await this._vm.axios.post(this._vm.endpoint.get('ecommerce_order_payment_collection'), {order_id, amount, note})
        return response.data
    },

    async deletePaymentCollection({commit}, {id}) {
        const response = await this._vm.axios.delete(this._vm.endpoint.get('ecommerce_order_payment_collection') + '/' + id)
        return response.data
    },

    // ─── Usage date operations (kullanım tarihi) ─────────────────────
    // Tek sipariş öğelerinin kullanım tarihlerini güncelle
    async changeUsage({commit}, {order_id, items}) {
        const response = await this._vm.axios.put(this._vm.endpoint.get('ecommerce_order_item_change_usage') + '/' + order_id, {items})
        return response.data
    },

    // Toplu kullanım tarihi değişimi (arka plan işi)
    async changeUsageMulti({commit}, {data}) {
        const response = await this._vm.axios.post(this._vm.endpoint.get('ecommerce_order_item_change_usage_multi'), data)
        return response.data
    },

    async getUsageMultiTrack() {
        const response = await this._vm.axios.get(this._vm.endpoint.get('ecommerce_order_item_change_usage_multi') + '/track')
        return response.data.data
    },

    async cancelUsageJob({commit}, {id}) {
        const response = await this._vm.axios.delete(this._vm.endpoint.get('ecommerce_order_item_change_usage_multi') + '/' + id)
        return response.data
    },

    // ─── Shipping (kargo) ────────────────────────────────────────────
    async getShipping({commit}, {filterData} = {}) {
        const response = await this._vm.axios.get(this._vm.endpoint.get('ecommerce_order_shipping'), {
            params: Object.assign({sort: 'id:asc'}, filterData || {}),
        })
        return response.data.data
    },

    // Seçili siparişleri kargoya ver
    async processShipping({commit}, {orders}) {
        const response = await this._vm.axios.post(this._vm.endpoint.get('ecommerce_order_shipping'), {orders})
        return response.data
    },

    async getShippingDetails({commit}, {id}) {
        const response = await this._vm.axios.get(this._vm.endpoint.get('ecommerce_order_shipping_detail') + '/' + id)
        return response.data.data
    },

    // Taşıma irsaliyesi önizleme (blob)
    async waybillPreview({commit}, {orders}) {
        const response = await this._vm.axios.get(this._vm.endpoint.get('ecommerce_order_shipping_waybill_preview'), {
            params: {orders},
            responseType: 'blob',
        })
        return response
    },
}

// mutations
const mutations = {
    setLoading(state, val) {
        state.table.loading = val
    },
    updatePagination(state, pagination) {
        state.table.pagination = pagination
    },
    updateTableData(state, data) {
        state.table.data = data
    },
    updateStatuses(state, data) {
        state.statuses = data
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
